import { createUseStyles } from 'react-jss'

import { colors } from 'components/common'

const useRadioButtonGroupStyles = createUseStyles({
  radioBtnGroup: {
    height: 40,
    marginRight: '1.5rem'
  }
})

const useRadioButtonStyles = createUseStyles({
  radioBtn: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginRight: '1.5rem',
    alignItems: 'center',
    borderRadius: '40px',
    padding: '0.25rem 0',
    cursor: 'pointer'
  },
  radioBtnDisabled: {
    opacity: 0.4,
    pointerEvents: 'none'
  },
  circle: {
    height: '15px',
    width: '15px',
    borderRadius: '50%',
    border: '4px solid',
    backgroundColor: '#fff',
    borderColor: '#ddd',

    '&.checked': {
      backgroundColor: '#fff',
      borderColor: colors.primary1
    }
  },
  label: {
    paddingLeft: '0.5rem',
    cursor: 'pointer',
    color: colors.gray600,
    fontWeight: 'bold'
  }
})

export { useRadioButtonGroupStyles, useRadioButtonStyles }
